module.exports = {"pageTitleText":"服务管理"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-CN/appProfileSetting.json
// module id = xPcR
// module chunks = 3